module.exports = __webpack_public_path__ + "static/media/Youtube.2a14b2d0.svg";